import { WaterlilyClient, createQueryKeys } from '@client/api/waterlily';

export const inviteKeys = createQueryKeys('invite');

export const inviteApi = {
  sendInvite: (data: IntakeFormEmailProps) =>
    WaterlilyClient.post<{ success: boolean; result?: unknown; error?: string }>(
      '/intake-form-email',
      data,
    ),
  sendBatchInvite: (data: BatchIntakeFormEmailProps) =>
    WaterlilyClient.post<BatchEmailReminderResult>('/batch-intake-form-email', data),
};

export interface QuickClientWithFormRequest {
  advisorId: string;
  firstName: string;
  lastName: string;
  email?: string;
  clientRelationshipStage?: ClientRelationshipStage;
  acknowledgedEdjSelfPlanConsent?: boolean;
}

export interface QuickClientWithFormResponse {
  clientId: string;
  formReferenceId: string;
}

export const quickClientKeys = createQueryKeys('quickClient');

export const quickClientApi = {
  createQuickClientWithForm: (data: QuickClientWithFormRequest) =>
    WaterlilyClient.post<QuickClientWithFormResponse>(
      `/advisor/${data.advisorId}/quick-client-with-form`,
      data,
    ),
};
